<template>
<div class="field location">
  <autocomplete :label="label" :placeholder="placeholder"
    v-model="locations" :showSuggestions="suggestions.length > 0 && focused"
    :error="error"
    v-on:keyup.enter="onReturnKey"
    v-on:blur="onBlur"
    v-on:focus="onFocus"
    v-on:text="onTextChange">
    <ul class="locationDropDown">
      <li class="row" v-for="(suggestion, index) in suggestions" :key="index"
        @click.stop.prevent="selected(suggestion)">
        <span>{{ suggestion.title }}</span>
      </li>
    </ul>
  </autocomplete>
</div>
</template>

<script>
import Autocomplete from '@/components/general/autocomplete-tag-field'
import Locations from '@/api/locations'

export default {
  components: { Autocomplete },
  props: {
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: Array,
      required: false
    },
    error: {
      type: String,
      default: null
    }
  },
  methods: {
    updateText (text) {
      if (text.length > 3 && this.focused) {
        this.updateSuggestions(text)
      } else {
        this.suggestions = []
      }
    },
    async updateSuggestions (text) {
      const suggestions = await Locations.autocomplete(text)

      const map = this.value.reduce((res, x) => {
        res[x.placeId] = 1
        return res
      }, {})
      this.suggestions = suggestions.filter(x => map[x.placeId] !== 1)
    },
    onBlur () {
      window.setTimeout(() => {
        // this.focused = false
        this.$emit('validate')
      }, 250)
    },
    onFocus () {
      this.focused = true
      this.suggestions = []
    },
    onTextChange (value, oldValue) {
      if (value.length > 0) {
        this.updateText(value)
      }
    },
    selected (suggestion) {
      this.text = suggestion.title
      this.focused = false
      const current = this.value.concat([{
        placeId: suggestion.placeId,
        title: suggestion.title
      }])
      this.$emit('input', current)
    }
  },
  computed: {
    locations: {
      get () { return this.value.map(x => x.title) },
      set (value) {
        const locs = value.reduce((res, loc) => {
          res[loc] = 1
          return res
        }, {})
        const v = this.value.filter(x => locs[x.title] === 1)
        this.$emit('input', v)
      }
    }
  },
  data () {
    return {
      suggestions: [],
      focused: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.row {
  padding: 0.5rem;
  &:hover {
    background-color: $hover-background;
    cursor: pointer;
  }
}
.field.is-grouped.is-grouped-multiline:last-child {
  margin-bottom: 0 !important;
}

.locationDropDown {
  margin-top: .5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/general/location-tag-autocomplete.vue